import { Injectable } from '@angular/core';
import { ICvxClaimsPrincipal } from '@cvx/cal-angular';
import { UserProfile } from '@models/user-profile';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggedInUserService {
  private currentUserSubject = new BehaviorSubject<UserProfile | null>(null);
  public currentUser$: Observable<UserProfile | null> = this.currentUserSubject.asObservable();

  constructor() {}

  setCurrentUser(data: ICvxClaimsPrincipal): void {
    this.currentUserSubject.next(data);
  }
}